import { useMemo } from "react";
import ShareDialog from "@/components/shared/ShareDialog";
import { buildSchoolShareMessages } from "@/lib/shareMessages";

/** Share the school's donation page (admin and teacher dashboards). */
export default function SchoolShareDialog({ url, schoolName, triggerLabel = "Share donation page", triggerVariant = "default", ...trigger }) {
  const messages = useMemo(() => buildSchoolShareMessages({ schoolName, url }), [schoolName, url]);

  return (
    <ShareDialog
      url={url}
      title="Share your donation page"
      description="For a newsletter, a parent email or a community post."
      messages={messages}
      emailSubject={`${schoolName}'s read-a-thon`}
      shareTitle={`${schoolName}'s read-a-thon`}
      triggerLabel={triggerLabel}
      triggerVariant={triggerVariant}
      {...trigger}
    />
  );
}
